import React from 'react';
import { Modal } from 'antd';

const ConfirmDeleteModal = ({ visible, onConfirm, onCancel }) => (
  <Modal
    title="Potvrda brisanja"
    visible={visible}
    onOk={onConfirm}
    onCancel={onCancel}
    okText="Obriši"
    cancelText="Otkaži"
  >
    <p>Da li ste sigurni da želite obrisati?</p>
  </Modal>
);

export default ConfirmDeleteModal;
